export default __webpack_public_path__ + "static/media/black.20d13dde.png";